import React from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import Ax from "../../components/hoc/Ax";
import HttpAPICall from '../../services/HttpAPICall';
import TapApiUrls, { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import AppBaseComponent from '../../components/AppBaseComponent';
import TapIcon from '../../services/TapIcon';
import Loader from '../../components/ui/Loader/Loader';
import { Modal } from "bootstrap";
import TapSelect from '../../components/ui/TapSelect';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import AdditionalAttributeForm from '../includes/ui/AdditionalAttributeForm';

class StartProject extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initialProjectStructure = {
            name: '',
            notes: ''
        }

        this.initialSearch = {
            search_by_name: '',
            search_status_id: '',
        }

        this.initialProjectStartForm = {
            site_id: '',
            notes: '',
            structure_id: '',
            name: '',
            category_id: '',
        }

        this.searchFormLabel = {
            'search_by_name': 'Name : ',
            'search_status_id': 'Status : ',
        };

        this.state = {
            minimizeTable: false,
            listing_loading: false,
            formSubmitting: false,
            modalLoading: false,
            totalListingCount: 0,
            listingMeta: null,
            listingData: [],
            configurationData: null,
            addProjectStructureForm: { ...this.initialProjectStructure },
            projectDetailData: null,
            projectStructureId: '',
            status: [{ label: 'Active', value: 1 }, { label: 'Inactive', value: 2 }],
            searchFormData: { ...this.initialSearch },
            submittedSearchFormData: { ...this.initialSearch },
            formSearchedElems: [],
            startProjectForm: { ...this.initialProjectStartForm },
            structures: [],
            siteList: [],
            categories: [],
        }

        this.projectStructureUrl = IAM_API_BASE_URL_2 + '/project_structure';
        this.projectUrl = IAM_API_BASE_URL_2 + '/project';
        this.detailDataLoad = React.createRef();
    }
    componentDidMount() {
        this.showModal()
    }

    showModal = () => {
        this.setState({ projectStructureId: this.props?.location?.state?.projectStructureId });
        this.setState({ modalLoading: true });
        const sites = this.props.group_sites;
        HttpAPICall.withAthorization('GET', this.projectUrl + '/form_data', this.props.access_token, null, null, (response) => {
            const structures = response.data.structures;
            const structure_id = this.state.projectStructureId;

            const selectedStructure = structures.find(s => s.id === structure_id);

            let updatedForm = {
                ...this.state.startProjectForm,
                structure_id,
                category_id: selectedStructure?.category?.id || ''
            };
            response.data.additional_attributes.forEach(attr => {
                updatedForm["additional_attributes_" + attr.key] = "";
            });

            if (selectedStructure && selectedStructure.additional_attributes) {
                selectedStructure.additional_attributes.forEach(attr => {
                    updatedForm["additional_attributes_" + attr.key] = attr.value || "";
                });
            }

            this.setState({
                formData: response.data,
                structures: structures && structures.length > 0
                    ? structures.map(s => ({ label: s.name, value: s.id, category: s.category }))
                    : [],
                startProjectForm: updatedForm,
                siteList: sites && sites.length > 0
                    ? sites.map(site => ({ label: site.site_name, value: site.id }))
                    : [],
                categories: response.data.categories.map(c => ({ label: c.name, value: c.id }))
            });
        }).then(() => this.setState({ modalLoading: false }));
    }
    startProjectInit = () => {
        this.startProject.show();
        this.setState({ modalLoading: true });
        const sites = this.props.group_sites;
        HttpAPICall.withAthorization('GET', this.projectUrl + '/form_data',
            this.props.access_token, null, null, (response) => {
                const structures = response.data.structures;
                this.setState({
                    structures: structures && structures.length > 0 ? structures.map(s => { return { label: s.name, value: s.id } }) : [],
                    startProjectForm: { ...this.state.startProjectForm, structure_id: this.state.projectStructureId },
                    siteList: sites && sites.length > 0 ? sites.map(site => { return { label: site.site_name, value: site.id } }) : []
                })
            }).then(() => this.setState({ modalLoading: false }));

    }
    startFormSubmit = (e) => {
        e.preventDefault();
         const form = { ...this.state.startProjectForm };
        let additional_attributes = {};
        this.state.formData.additional_attributes.forEach(attr => {
            const key = attr.key;
            const fieldName = "additional_attributes_" + key;
            additional_attributes[key] = form[fieldName] || "";
            delete form[fieldName];
        });
        const data = {
            ...form,
            additional_attributes
        };
        this.setState({
            formSubmitting: true
        })
        HttpAPICall.withAthorization('POST', this.projectUrl + '/start',
            this.props.access_token, null, data, (response) => {
                toast.success(response.data?.msg, { position: toast.POSITION.TOP_RIGHT })
                this.setState({
                    startProjectForm: this.initialProjectStartForm
                }
                )
                this.closeEvent()
            }).then(() => this.setState({ formSubmitting: false }));
    }

    closeEvent = () => {
        this.props.history.push({ pathname: `/project` })
    }
    render() {
        return (
            <>
                <ApplicationLayout>
                    <Helmet><title>Project Add</title></Helmet>
                    <div className="page_title row m0">
                        <div className="col-12">
                            <h3> Start A Project</h3>
                            <div className="text-end mt15">
                                <button onClick={this.closeEvent} type="button" className="btn btn-secondary">
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close " />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="page_containt row pl2">
                            <div className="col-12 pl4"
                                style={{ overflowY: "auto", height: "calc(100vh - 130px)", padding: "0px", backgroundColor: "white" }}>
                                {this.state.modalLoading
                                    ? <Loader />
                                    :
                                    <Ax>
                                        <form id="startProjectForm" onSubmit={this.startFormSubmit} className="bg-white p-3">
                                            <div className="row align-items-center">
                                                <div className="col-3">
                                                    <label htmlFor="name" className="form-label require">Project Template</label>
                                                </div>
                                                <div className="col-7">
                                                    <TapSelect
                                                        changeEvent={(selectedOption) => {
                                                            let selectValue = selectedOption ? selectedOption.value : "";

                                                            const selectedStructure = this.state.formData.structures.find(
                                                                s => s.id === selectValue
                                                            );

                                                            let updatedForm = {
                                                                ...this.state.startProjectForm,
                                                                structure_id: selectValue,
                                                                category_id: selectedStructure?.category?.id || ''
                                                            };
                                                            this.state.formData.additional_attributes.forEach(attr => {
                                                                updatedForm["additional_attributes_" + attr.key] = "";
                                                            });

                                                            if (selectedStructure && selectedStructure.additional_attributes) {
                                                                selectedStructure.additional_attributes.forEach(attr => {
                                                                    updatedForm["additional_attributes_" + attr.key] = attr.value || "";
                                                                });
                                                            }

                                                            this.setState({
                                                                startProjectForm: updatedForm
                                                            });
                                                        }}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        isDisabled={this.state.projectStructureId ? true : false}
                                                        placeholder="Select Project Template"
                                                        options={this.state.structures}
                                                        value={this.state.structures.find(s => s.value === this.state.startProjectForm.structure_id)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row align-items-center mt-1">
                                                <div className="col-3">
                                                    <label htmlFor="name" className="form-label require">Category</label>
                                                </div>
                                                <div className="col-sm-7 mb-2">
                                                    <TapSelect
                                                        options={this.state.categories}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        isDisabled={true}
                                                        value={this.state.categories.find(s => this.state.startProjectForm.category_id === s.value)}
                                                        placeholder="Select Category"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row align-items-center">
                                                <div className="col-3">
                                                    <label htmlFor="name" className="form-label require">Site</label>
                                                </div>
                                                <div className="col-sm-7 mb-2">
                                                    <TapSelect
                                                        changeEvent={(selectedOption) => {
                                                            this.tapSelectChange(selectedOption, 'startProjectForm', 'site_id');
                                                        }}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select Site"
                                                        options={this.state.siteList}
                                                        value={this.state.siteList.find(s => s.value === this.state.startProjectForm.site_id)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="row align-items-center">
                                                <div className="col-3">
                                                    <label htmlFor="name" className="form-label require">Name</label>
                                                </div>
                                                <div className="col-sm-7">
                                                    <input
                                                        name="name"
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={this.state.startProjectForm.name}
                                                        onChange={(e) => this.formInputHandler(e, 'startProjectForm')}
                                                        placeholder="Enter Name"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                {this.state.formData &&
                                                    this.state.formData.additional_attributes &&
                                                    this.state.formData.additional_attributes.length > 0 && (
                                                        <AdditionalAttributeForm
                                                            additionalAttributes={this.state.formData.additional_attributes}
                                                            formState={this.state.startProjectForm}
                                                            onAttributeChange={(value, attributeName) => {
                                                                this.setState(() => ({
                                                                    startProjectForm: {
                                                                        ...this.state.startProjectForm,
                                                                        [attributeName]: value,
                                                                    },
                                                                }));
                                                            }}
                                                            colSpan={"col-sm-7"}
                                                        />
                                                    )}
                                            </div>
                                            <div className="row align-items-center mt-2">
                                                <div className="col-3">
                                                    <label htmlFor="name" className="form-label require">Notes</label>
                                                </div>
                                                <div className="col-sm-7">
                                                    <textarea
                                                        name="notes"
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={this.state.startProjectForm.notes}
                                                        onChange={(e) => this.formInputHandler(e, 'startProjectForm')}
                                                        placeholder="Enter Notes..."
                                                    />
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 justify-content-end me-5 mt-5">
                                                <button type="button" className="btn btn-secondary" onClick={this.closeEvent}  disabled={this.state.formSubmitting}>Cancel</button>
                                                <button type="submit" form='startProjectForm' className="btn btn-primary" disabled={this.state.formSubmitting} >Start {this.state.formSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                                            </div>
                                        </form>
                                    </Ax>
                                }
                            </div>
                        </div>
                    </div>
                </ApplicationLayout>
            </>
        )
    }

}



const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        permissions: state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [],
        group_sites: state.app.group_sites && state.app.group_sites.length > 0 ? state.app.group_sites : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(StartProject);




